import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { UserService } from "../services/user/user.service";
import { TokenPayload } from "../models/token";

export interface RouteInfo {
    path: string;
    title: string;
    icon: string;
    class: string;
    type:string;
}

export const ROUTES: RouteInfo[] = [
    {
        path: '/records',
        title: 'Records',
        icon: 'nc-badge',
        class: '',
        type: 'records'
    },
    {
        path: '/users',
        title: 'Users',
        icon: 'nc-single-02',
        class: '',
        type: 'users'
    },
    {
        path: '/sites',
        title: 'Sites',
        icon: 'nc-world-2',
        class: '',
        type: 'sites'
    },
    {
        path: '/surveys',
        title: 'Surveys',
        icon: 'nc-ruler-pencil',
        class: '',
        type: 'surveys'
    },
    {
        path: '/reports',
        title: 'Reports',
        icon: 'nc-single-copy-04',
        class: '',
        type: 'reports'
    },
    {
        path: '/navigation',
        title: 'Navigation',
        icon: 'nc-map-big',
        class: '',
        type: 'navigation'
    },
];

@Component({
    moduleId: module.id,
    selector: 'sidebar-cmp',
    templateUrl: 'sidebar.component.html',
})

export class SidebarComponent implements OnInit {
    public menuItems: any[];

    public signOutItem: RouteInfo = {
        path: '/login',
        title: 'Sign out',
        icon: 'nc-button-power',
        class: 'active-pro',
        type: 'logout'
    };


    permissions: any = {
        sites: false,
        surveys: false,
        users: false,
        records: false,
        reports: false,
        navigation: false,
    };
    // @ts-ignore
    sidebarTitle = window.sidebarTitle || 'Impi Tech';

    constructor(private router: Router,
        private userService: UserService) {
            try {
                // Check to validate if a user logged in
                let user = this.userService.getUser();
                if (user == null) {
                    this.router.navigate(['login']);
                }
                // Get User permissions from token
                let tokenPayloadStr = atob(user.token.split('.')[1]);
                let temptokenPayload = JSON.parse(tokenPayloadStr);
                let tokenPayload:TokenPayload = temptokenPayload.jwtContent;
                // Set User permissions
                this.permissions.sites = tokenPayload.permissions.sites?.includes('view');
                this.permissions.surveys = tokenPayload.permissions.surveys?.includes('view');
                this.permissions.users = tokenPayload.permissions.users?.includes('view');
                this.permissions.records = tokenPayload.permissions.records?.includes('view');
                this.permissions.reports = tokenPayload.permissions.reports?.includes('view');
                this.permissions.navigation = tokenPayload.permissions.navigation?.includes('view');
            } catch (error) 
            {
                console.log(error);
                this.router.navigate(['login']);
            }
        }

    ngOnInit() {
        // Add user role check here
        this.menuItems = ROUTES.filter(menuItem => {
            if (this.permissions[menuItem.type] === true) {
                return menuItem
            }
        });
    }

    logout()
    {
        localStorage.removeItem('user');
        this.router.navigate(['/login']);
    }   
}
